// SINGLE SOURCE OF TRUTH for all Vyvron pricing — change a price HERE ONLY.
// MWL uses founding/standard pricing like Microdose and Longevity.
// Static HTML mirrors must be updated by hand whenever pricing changes.

const price = (amount, display) => Object.freeze({ amount, display });

export const PRICING = Object.freeze({
  medicalWeightLoss: Object.freeze({
    standard: price(199, "$199"),
    founding: price(179, "$179"),
    foundingMembers: 100,
    terms: Object.freeze([
      [4, 179, "$179", 199, "$199"],
      [12, 500, "$500", 525, "$525"],
      [24, 915, "$915", 955, "$955"],
      [52, 1805, "$1,805", 1861, "$1,861"],
    ].map(([weeks, amount, display, standardAmount, standardDisplay]) => Object.freeze({
      weeks, label: `${weeks} weeks`, price: price(amount, display),
      standardPrice: price(standardAmount, standardDisplay),
    }))),
  }),
  microdose: Object.freeze({
    founding: price(149, "$149"),
    regular: price(179, "$179"),
    foundingMembers: 100,
    terms: Object.freeze([
      Object.freeze({ weeks: 4, label: "4 weeks", price: price(149, "$149") }),
      Object.freeze({ weeks: 12, label: "12 weeks", price: price(422, "$422") }),
      Object.freeze({ weeks: 24, label: "24 weeks", price: price(794, "$794") }),
      Object.freeze({ weeks: 52, label: "52 weeks", price: price(1612, "$1,612") }),
    ]),
  }),
  longevity: Object.freeze({
    foundingMembers: 100,
    products: Object.freeze({
      nadCellularRecharge: Object.freeze({
        name: "NAD+ — Cellular Recharge",
        founding: price(189, "$189"),
        regular: price(229, "$229"),
      }),
      sermorelinPeakRecovery: Object.freeze({
        name: "Sermorelin — Peak Recovery",
        founding: price(179, "$179"),
        regular: price(199, "$199"),
      }),
      metabolismBoost: Object.freeze({
        name: "Metabolism Boost — B12 + MIC",
        founding: price(99, "$99"),
        regular: price(119, "$119"),
      }),
    }),
  }),
});

const PROGRAM_PRICING = Object.freeze({
  medicalWeightLoss: PRICING.medicalWeightLoss,
  microdose: PRICING.microdose,
  longevity: PRICING.longevity.products.nadCellularRecharge,
});

const CANCELLATION_LINE = "Cancel anytime by emailing support@vyvron.com — effective at the end of your billing cycle, no fees.";

export const PRICE_COPY = Object.freeze({
  medicalWeightLossPricingLine: `Limited-time offer — ${PRICING.medicalWeightLoss.founding.display} every 4 weeks (regularly ${PRICING.medicalWeightLoss.standard.display}).`,
  medicalWeightLossTermsLine: `Limited-time term pricing: ${PRICING.medicalWeightLoss.terms.map(term => `${term.price.display} for ${term.label}`).join(", ")}. Regular rates: ${PRICING.medicalWeightLoss.terms.map(term => term.standardPrice.display).join(" / ")}.`,
  medicalWeightLossOfferLine() {
    return `${this.medicalWeightLossPricingLine} ${CANCELLATION_LINE}`;
  },
  foundingOfferLine(program) {
    return `Limited-time offer — ${PROGRAM_PRICING[program].founding.display} every 4 weeks (regularly ${PROGRAM_PRICING[program].regular.display}).`;
  },
  foundingReturnLine(program) {
    return `Limited-time offer — ${PROGRAM_PRICING[program].founding.display} every 4 weeks (regularly ${PROGRAM_PRICING[program].regular.display}).`;
  },
  roscaBillingLine(program) {
    if (program === "medicalWeightLoss") {
      return `${PRICING.medicalWeightLoss.founding.display} every 4 weeks, billed every 4 weeks; auto-renews at ${PRICING.medicalWeightLoss.founding.display} until you cancel. ${CANCELLATION_LINE}`;
    }
    return `${PROGRAM_PRICING[program].founding.display} per 4 weeks, billed every 4 weeks; auto-renews until you cancel. ${CANCELLATION_LINE}`;
  },
  termBillingAndCancellationLine: `Billed per term; auto-renews until you cancel. ${CANCELLATION_LINE}`,
  cancellationLine: CANCELLATION_LINE,
  standardDisclosureLine: "Compounded medications are not FDA-approved.",
});
